import React, { useState } from "react";
import CustomModal from "../../../components/generic/custommodal/CustomModal";
import SecondaryButton from "../../../components/generic/buttons/SecondaryButton";
import EnableNotificationIcon from "../../landingpage/install/EnableNotificationIcon";
import NotificationList from "./NotificationList";
import { useReadMemory } from "../../generic/hooks/useReadMemory";
import MemoryType from "../../../service/memory/enum/MemoryType";
import { useRecoilState } from "recoil";
import { notifications } from "../../../components/recoil/notificationsRecoil";
import apiService from "../../../service/apiservice/apiService";

const isDismissibleNotification = (notification) => {
  try {
    const message = JSON.parse(notification?.message || "{}");
    return message?.dismissible !== false;
  } catch {
    return true;
  }
};

const NotificationModal = ({ modal, setModal }) => {
  const user = useReadMemory(MemoryType.USER);
  const [notificationList, setNotificationList] = useRecoilState(notifications);
  const [isClearing, setIsClearing] = useState(false);

  const handleClearAll = async () => {
    if (!notificationList?.length || isClearing) {
      return;
    }

    setIsClearing(true);
    const payload = [
      {
        actionType: "read",
        value: "true",
        actionOwnerType: "workforce",
        actionOwner: user?.userIdentifier,
      },
    ];

    const dismissibleNotifications = notificationList.filter(
      isDismissibleNotification,
    );

    if (!dismissibleNotifications.length) {
      setIsClearing(false);
      return;
    }

    const updateResults = await Promise.allSettled(
      dismissibleNotifications.map((item) =>
        apiService.post(
          `niramayafoundation/api/v1/communication/message/actions?messageId=${item?.id}`,
          payload,
        ),
      ),
    );

    const clearedIds = new Set();
    dismissibleNotifications.forEach((item, index) => {
      const result = updateResults[index];
      if (result?.status === "fulfilled" && result?.value?.length > 0) {
        clearedIds.add(item?.id);
      }
    });

    setNotificationList((prevNotifications) =>
      prevNotifications.filter((item) => !clearedIds.has(item?.id)),
    );

    setIsClearing(false);
  };

  const footerButtons = (
    <SecondaryButton buttonText="Close" handleOnClick={() => setModal(false)} />
  );

  return (
    <CustomModal
      isModalOpen={modal}
      footer={footerButtons}
      closeModal={setModal}
      title="Notifications"
    >
      <EnableNotificationIcon />
      {Boolean(notificationList?.length) &&
        notificationList.some(isDismissibleNotification) && (
          <div className="text-right">
            <SecondaryButton
              buttonText="Clear All"
              handleOnClick={handleClearAll}
              buttonDisable={
                !notificationList?.length ||
                !notificationList.some(isDismissibleNotification)
              }
              loading={isClearing}
            />
          </div>
        )}
      <NotificationList />
    </CustomModal>
  );
};

export default NotificationModal;
